<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class="fas fa-file-invoice-dollar mr-2" />
                    Compra de cripto
                </h2>
                <action-buttons />
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto px-6 lg:px-8">
                <div v-if="showPurchase">
                    <flash :timeout="5000" />
                    <balance-crypto class="mb-5" />
                    <section class="flex flex-wrap justify-center">
                        <price-crypto
                            :is-buying="true"
                            :price-box-title="'Compra de cripto'"
                            :is-change-perspective="isChangePerspective"
                            :send-order="sendOrder"
                            :processing-order="form.processing"
                            @change-perspective="
                                isChangePerspective = !isChangePerspective
                            "
                            @att-form="attForm"
                        />
                    </section>
                </div>
                <div
                    v-else
                    class="bg-white rounded shadow-lg p-8 max-w-min text-center mx-auto"
                >
                    <h2 class="text-xl font-bold">
                        Serviço indisponível neste horário
                    </h2>
                    <p class="text-sm text-gray-500 whitespace-nowrap">
                        Compra de cripto moedas é liberada somente das 9:05h as
                        16:33h
                    </p>
                    <img class="w-64 mx-auto my-6" src="/images/block-cripto.png" alt="">
                    <p class="text-sm text-gray-500">
                        A compra será liberada daqui
                    </p>
                    <h2 class="text-xl font-bold mb-6">{{ timer }}</h2>
                    <inertia-link
                        class="
                            flex items-center px-6 py-3 border border-transparent
                            rounded font-semibold text-xs text-white tracking-widest
                            hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900
                            focus:shadow-outline-gray transition ease-in-out duration-150
                            bg-gray-800 max-w-min whitespace-nowrap mx-auto
                        "
                        :href="route('buy.index')"
                    >
                        Tentar novamente
                    </inertia-link>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout.vue";
import Flash from "../../../Helpers/Flash.vue";
import PriceCrypto from "../components/PriceCrypto.vue";
import Balance from "../../../Helpers/Balance.vue";
import CryptoBalance from "../Balance";
import ActionButtons from "../ActionButtons.vue";
import BalanceCrypto from "../Balance.vue";
import moment from 'moment';

export default {
    data() {
        return {
            isChangePerspective: true,
            showPurchase: true,
            form: this.$inertia.form(
                {
                    quote: {
                        id: null,
                        coin: null,
                        settlement: null,
                        value: null,
                        date: null,
                        total: null,
                        amount: null,
                        request_date: null
                    }
                },
                {
                    resetOnSuccess: false
                }
            ),
            timer: '8 h 30 m 10 s',
            interval: 0
        };
    },
    created(){
        this.stopwatch()
    },
    mounted() {
        this.interval = setInterval(this.stopwatch, 1000)
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        stopwatch(){
            const date = moment()
            const dateInicial = `${moment().format('YYYY-MM-DD')}T09:04:59`
            const dateFinal = `${moment().format('YYYY-MM-DD')}T16:33:00`

            const showTime = (diff) => {
                const duration = moment.duration(Math.abs(diff))
                this.timer = `${duration.hours()} h ${duration.minutes()} m ${duration.seconds()} s`
            }
            if (moment().isBetween(dateInicial, dateFinal)) {
                return this.showPurchase = true
            } else if (date.hours() <= 9 && date.minutes() < 5) {
                const diff = moment().diff(moment(dateInicial))
                showTime(diff)
            } else {
                const diff = moment().diff(moment(dateInicial).add(1, 'day'))
                showTime(diff)
            }
            this.showPurchase = false
        },
        sendOrder() {
            if (this.form.quote.value === 0) {
                this.$toast.open({
                    message: "O valor deve ser maior que zero",
                    type: "error",
                    duration: 5000,
                    position: "top-right"
                });

                return;
            }

            if (this.form.quote.amount < this.form.quote.min_lot_size) {
                this.$toast.open({
                    message: "O valor deve ser maior ou igual a $10.000,0000",
                    type: "error",
                    duration: 5000,
                    position: "top-right"
                });

                return;
            }

            this.form.post(this.route("trade.store"), {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.processing = false;
                },
                onError: e => {
                    this.$toast.open({
                        message:
                            e[0][0] ??
                            "Erro ao solicitar ordem, por favor tente novamente mais tarde",
                        type: "error",
                        duration: 5000,
                        position: "top-right"
                    });
                    this.form.processing = false;
                }
            });
        },
        attForm(data) {
            this.form.quote = data;
        }
    },
    components: {
        ActionButtons,
        AppLayout,
        Flash,
        PriceCrypto,
        Balance,
        CryptoBalance,
        BalanceCrypto
    }
};
</script>
